import React, { useState, useEffect } from "react";
import axios from "axios";
import ReactHtmlParser from "react-html-parser";
import { Link } from "react-router-dom";
import { decryptData, encryptData } from "../../decryptHelper";

export default function Notification() {
  const [users, setUsers] = useState([]);
  const [loading1, setLoading] = useState(false);

  // Popup State
  const [showPopup, setShowPopup] = useState(false);
  const [selectedId, setSelectedId] = useState("");
  const [message, setMessage] = useState("");

  useEffect(() => {
    loadUsers();
  }, []);

  const loadUsers = async () => {
    setLoading(true);

    try {
      const user_id = localStorage.getItem("userid");
      let url = `${process.env.REACT_APP_API_URL_NODE}boardcast`;
      const requestData = {
        app_id: process.env.REACT_APP_API_ID,
        user_id: user_id,
      };

      const encryptedText = encryptData(requestData);
      const datasend = { data: encryptedText };

      var config = {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        url: url,
        data: datasend,
      };

      axios(config)
        .then(function (response1) {
          const response = decryptData(response1.data.encryptedResponse);
          const res = JSON.stringify(response.data.data);
          const objectRes = JSON.parse(res);
          const userData = response.data.data;

          setUsers(userData);
          localStorage.setItem("notificationCount", userData.length);
        })
        .finally(() => {
          setLoading(false);
        });
    } catch (error) {
      console.error("Error fetching users:", error);
    } finally {
      setLoading(false);
    }
  };
  const sendMessage = async () => {
    try {
      const user_id = localStorage.getItem("userid");
      const requestData = {
        user_id: user_id,
        broadcast_id: selectedId,
        message: message,
      };

      const response = await axios({
        method: "POST",
        url: `${process.env.REACT_APP_API_URL_NODE}boardcast-revert`,
        headers: {
          "Content-Type": "application/json",
        },
        data: requestData,
      });

      // console.log(response.data);

      alert("Message Sent Successfully");
      loadUsers();
      setMessage("");
      setShowPopup(false);
    } catch (error) {
      console.log(error);
      alert("Something went wrong");
    }
  };

  return (
    <>
      <section id="notification">
        <div className="margin-bottom-88">
          {users &&
            users.map((user, index) => (
              <div className="notficationbox" key={index}>
                <div className="d-flex justify-content-between align-items-center">
                  <h6 className="titlenotification">{user.title}</h6>
                </div>

                <p className="notificationdes">
                  {ReactHtmlParser(user.message)}
                  <br />

                  {user.link && <Link to={user.link}>{user.link}</Link>}
                </p>

                {/* Video */}
                {user?.type === "video" && (
                  <video controls width="50%" height="150px">
                    <source src={user.media} />
                  </video>
                )}

                {/* Image */}
                {user?.type === "image" && (
                  <img src={user.media} alt="User" style={{ width: "50px" }} />
                )}

                <div className="d-flex justify-content-between">
                  <time className="time">Date: {user.date}</time>
                </div>

                {/* Button */}
                {user?.is_read == 0 ? (
                  <button
                    className="btn btn-primary btn-sm reply_btn"
                    onClick={() => {
                      setShowPopup(true);
                      setSelectedId(user.id);
                    }}
                  >
                    Reply
                  </button>
                ) : (
                  <></>
                )}
              </div>
            ))}

          {/* Popup */}
          {showPopup && (
            <div
              style={{
                position: "fixed",
                top: 0,
                left: 0,
                width: "100%",
                height: "100%",
                background: "rgba(0,0,0,0.5)",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                zIndex: 999,
              }}
            >
              <div
                style={{
                  background: "#fff",
                  padding: "20px",
                  borderRadius: "10px",
                  width: "300px",
                }}
              >
                <h4 className="text-dark"> Send Message</h4>

                <textarea
                  rows="5"
                  className="form-control"
                  placeholder="Enter message..."
                  value={message}
                  onChange={(e) => setMessage(e.target.value)}
                ></textarea>

                <div
                  style={{
                    marginTop: "15px",
                    display: "flex",
                    justifyContent: "space-between",
                  }}
                >
                  <button className="btn btn-success" onClick={sendMessage}>
                    Send
                  </button>

                  <button
                    className="btn btn-danger"
                    onClick={() => setShowPopup(false)}
                  >
                    Close
                  </button>
                </div>
              </div>
            </div>
          )}

          {/* Loader */}
          {loading1 && (
            <div className="spinner-wrapper">
              <div className="loadernew2"></div>
            </div>
          )}
        </div>
      </section>
    </>
  );
}
